<style></style>
<template>
  <div class="w-100">
    <form
      class="w-100"
      @submit="buscarProductoBarra"
      v-if="facturae && facturae.estado == 'A'"
    >
      <div class="col-sm-12 mt-3 w-100 px-0 px-md-3">
        <div class="form-group w-100">
          <label
            v-bind:class="{
              'text-danger':
                current.errors.codigobarra &&
                current.errors.codigobarra.length > 0
            }"
            ><b>Agregar Producto</b></label
          >
          <div class="input-group">
            <input
              v-model="currentCodigobarra"
              class="form-control text-center white_gradient_bg_light shadow_inset_sm py-3"
              ref="codigobarra"
              placeholder="Código de Barra"
              autofocus
              :disabled="!isDetallesOCCargados" 
              v-bind:class="{
                'is-invalid':
                  current.errors.codigobarra &&
                  current.errors.codigobarra.length > 0
              }"
              type="text"
            />
            <div class="input-group-append">
              <button :disabled="!isDetallesOCCargados" type="submit" class="btn btn-dark" title="Buscar">
                <i class="fas fa-barcode fa-3x"></i>
              </button>
            </div>
          </div>
          <small
            v-if="current.errors && current.errors.codigobarra"
            class="form-text text-danger"
            >{{ current.errors.codigobarra[0] }}</small
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      cb: "",
      barra: "",
      um: "",
      currentCodigobarra: "",
      current: {
        codigobarra: "",
        producto: null,
        tienda: "",
        orden_compra: {
          cantidad_um: null,
          numero_orden: null,
          unidad_medida: {
            cantidad_unidades: null,
            id: null,
            nombre: null
          }
        },
        errors: []
      }
    };
  },
  props: ["facturae", "isDetallesOCCargados"],
  computed: {},
  mounted() {
    if (this.$refs.codigobarra) {
      this.$refs.codigobarra.focus();
    }
  },
  methods: {
    buscarProductoBarra(e) {
      let self = this;
      e.preventDefault();
      self.barra = self.currentCodigobarra;
      if (!self.barra) {
        Notifications.alert.error(
          "Producto",
          "el campo de barra no puede estar en blanco"
        );
        return;
      }
      DynamicService.getActionList(
        "cat",
        "producto-barra",
        "obtener_barra_permitir_compra",
        {
          barra: self.barra,
          factura_e_id: self.facturae.id
        }
      )
        .then(res => {
          const data = res.data;
          self.cb = data.producto;
          const ordenCompraInfo = data.orden_compra_info;
          console.log("sku escaneado: ", self.cb);

          /**
           * Si el producto existe en orden de compra
           */
          if (
            ordenCompraInfo &&
            Array.isArray(ordenCompraInfo) &&
            ordenCompraInfo.length > 0
          ) {
            self.current.orden_compra = ordenCompraInfo;
            self.current.tienda = ordenCompraInfo[0].tienda_orden;
            self.current.orden_compra_e = ordenCompraInfo[0].orden_compra_e;
          } else if (data.producto_obj.is_comodin === true) {
            self.current.orden_compra = [];
            self.current.tienda = null;
          } else {
          }

          self.current.producto = data.producto_obj;
          self.enviarDatos(self.cb);
        })
        .catch(err => {
          const mensaje =
            err.response && err.response.data && err.response.data.mensaje
              ? err.response.data.mensaje
              : "barra no existe";
          Notifications.alert.error("Producto", mensaje, err);
        });
    },
    enviarDatos(cb) {
      let self = this;

      /**
       * Se envía lo datos obtenidos por la barra al componente de agregar producto detalle
       */
      cb = self.cb;
      self.current.resetReceptionNumbers = true;

      self.$router.push({
        name: "RecepcionAgregarProductoDetalle",
        params: {
          sku: cb,
          facturaeId: self.facturae.id,
          current: self.current
        }
      });
    },
    refresh() {
      this.$emit("refrescar", {});
    }
  }
};
</script>
